<template>
  <div>
    <!-- 面包屑导航区 -->
    <!--   <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>农场管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/products_farm' }"
        >餐品列表</el-breadcrumb-item
      >
      <el-breadcrumb-item>添加餐品</el-breadcrumb-item>
    </el-breadcrumb> -->
    <!-- 卡片视图 -->
    <el-card>
      <!-- 提示 -->
      <el-alert
        title="添加餐品信息"
        type="info"
        center
        show-icon
        :closable="false"
      ></el-alert>
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addFormRef"
        label-width="100px"
        label-position="top"
      >
        <el-form-item label="餐品名称">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="餐品价格">
          <el-input v-model="addForm.price"></el-input>
        </el-form-item>
        <el-form-item label="餐品规格">
          <el-input
            v-model="addForm.specification"
            placeholder="请输入产品规格"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属农场">
          <el-select
            style="width: 100%"
            v-model="addForm.farm_id"
            placeholder="请选择所属农场"
          >
            <el-option
              v-for="item in farmList"
              :key="item.id"
              :label="item.FarmName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="库存数量(份)">
          <el-input v-model="addForm.inventory" type="number"></el-input>
        </el-form-item>
        <!-- <el-form-item label="计量单位">
          <el-input v-model="addForm.unit" type="text"></el-input>
        </el-form-item> -->
        <el-form-item label="餐品图片">
          <upload
            name="food"
            :initFileList="initFileList"
            @handleUploadSuccess="handleUploadSuccess"
            @handleRemove="handleRemove"
          ></upload>
        </el-form-item>
        <el-form-item label="餐品详情">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 20 }"
            placeholder="餐品详情"
            v-model="addForm.description"
          >
          </el-input>
        </el-form-item>
        <el-button type="primary" class="btnAdd" @click="addAction"
          >添加餐品</el-button
        >
      </el-form>
    </el-card>
  </div>
</template>

<script>
import _ from "lodash";
import { attributeList, supplierList } from "@/config/config.js";
import upload from "@/components/upload";
export default {
  components: {
    upload,
  },
  props: {
    detail: Object,
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    detail: {
      handler(nval, oval) {
        if(!nval){
          return
        }
        // this.addForm = nval || {};
        this.addForm = nval ? _.cloneDeep(nval) : {};
        this.addForm.price = this.addForm.price ? this.$round( this.addForm.price ) : 0;
						// for (let key in this.addForm) {
						// 	this.addForm[key] = _newObj[key];
						// }
        if (this.addForm.image) {
          this.initFileList = [
            {
              url: this.addForm.image,
            },
          ];
        } else {
          this.initFileList = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      addForm: {
        name: "",
        specification: "",
        image: "",
        inventory:"",
        price: "",
        description: "",
        // unit: "",
        farm_id: "",
      },
      dateRange: "",
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入餐品名称",
            trigger: "blur",
          },
        ],
        specification: [
          {
            required: true,
            message: "请选择餐品规格",
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: "请选择餐品价格",
            trigger: "blur",
          },
        ],
        image: [
          {
            required: true,
            message: "请上传餐品照片",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "请填写餐品介绍",
            trigger: "blur",
          },
        ],
      },
      initFileList: [],
    };
  },
  created() {},
  computed: {
    farmList() {
      return this.$parent.$parent.farmList;
    },
  },
  methods: {
    // 级联选择器选中项变化时出发
    handleChange() {},
    // 监听图片上传成功事件
    handleRemove() {
      this.addForm.image = "";
    },
    // 监听图片上传成功事件
    handleUploadSuccess(response) {
      console.log('123123', response)
      this.addForm.image = response.value[0].url;
    },
    // 添加餐品
    addAction() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return this.$message.error("请填写必要的表单项！");
        let params = _.cloneDeep(this.addForm);
        params.price = params.price * 100;
        let url = "web_api/canteen/addFood";
        if (this.isEdit) {
          params.id = this.detail.id;
          url = "web_api/canteen/updateFood";
        }
        const { data: res } = await this.$http.post(
          url,
          params
        );
        if (res.code !== 200) return this.$message.error("添加餐品失败！");
        this.$message.success("添加餐品成功!");
        this.$emit("refreshList");
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-checkbox {
  margin: 0 8px 0 0 !important;
}

.previewImg {
  width: 100%;
}

.btnAdd {
  margin-top: 15px;
}
</style>
